import { Button, Descriptions, Divider, Drawer, Input, Space, Tag, Typography, message } from "antd"
import { arrayUnion, doc, updateDoc } from "firebase/firestore"
import React, { useState } from "react"
import { db } from "../../../firebase/config"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { Text } = Typography

const { TextArea } = Input

export default function PriceRequestSidebar({ data }) {
  const { user } = useAuthContext()
  const [open, setOpen] = useState(false)
  const [requestComment, setRequestComment] = useState("")

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  //send request
  const sendRequest = async () => {
    const ref = doc(db, "priceCalculation", data.id)

    // Use the client's current time; be cautious as this depends on the client's clock
    const newAdminRequest = {
      requestDate: new Date(),
      requestComment: requestComment,
      requestedById: user.uid,
      requestedBy: user.email,
      role: "admin",
    }

    await updateDoc(ref, {
      adminRequested: true,
      adminRequestStatus: 1,
      adminRequests: arrayUnion(newAdminRequest),
    })
      .then(() => {
        message.success("Request sent!")
      })
      .then(() => {
        onClose()
      })
      .catch((err) => {
        message.error("Error!")
        console.error(err)
      })
  }

  //returns prices
  const returnPrices = (prices, fixedPrices, fixed) => {
    const dynamicPriceCopy = Array.isArray(prices) ? [...prices] : []
    const fixedDynamicPriceCopy = Array.isArray(fixedPrices) ? [...fixedPrices] : []

    if (data.labelCount > 0) {
      const newPriceObject = {
        price: data.price,
        quantity: data.labelCount,
        id: Math.random().toString(), // Consider using a more reliable ID generation method
      }

      dynamicPriceCopy.push(newPriceObject)
      fixedDynamicPriceCopy.push(newPriceObject)
    }

    if (data.totalFixedPrice && fixed) {
      // Add the object with totalFixedPrice and quantity 1000
      fixedDynamicPriceCopy.push({
        price: data.totalFixedPrice,
        quantity: 1000,
        id: Math.random().toString(), // Consider using a more reliable ID generation method
      })
    }

    if (fixed && Array.isArray(prices)) {
      return (
        <>
          <Space direction="vertical">
            <Divider>
              <Tag color="red">Fixed Prices</Tag>
            </Divider>
            {fixedDynamicPriceCopy.map((item, index) => (
              <Descriptions size="small" column={2} key={item.id}>
                <Descriptions.Item label="quantity">{item.quantity}</Descriptions.Item>
                <Descriptions.Item label="price">{item.price}</Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </>
      )
    } else if (!fixed && Array.isArray(prices)) {
      return (
        <>
          <Space direction="vertical">
            <Divider>
              <Tag color="blue">Dynamic prices </Tag>
            </Divider>
            {dynamicPriceCopy.map((item, index) => (
              <Descriptions size="small" column={2} key={item.id}>
                <Descriptions.Item label="quantity">{item.quantity}</Descriptions.Item>
                <Descriptions.Item label="price">{item.price}</Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </>
      )
    } else {
      return null // or some fallback UI when there are no prices
    }
  }

  return (
    <>
      <Button style={{ background: "#ff7a45", color: "white" }} onClick={showDrawer} size="small">
        Ask
      </Button>
      <Drawer
        width={500}
        title={"Request for : " + data.product.productName}
        onClose={onClose}
        open={open}>
        <TextArea
          value={requestComment}
          onChange={(e) => setRequestComment(e.target.value)}
          placeholder="Type your comment here..."
          autoSize={{
            minRows: 5,
            maxRows: 25,
          }}
        />
        <Button style={{ marginTop: 15 }} onClick={sendRequest} block type="primary">
          Submit Request
        </Button>
        <Divider style={{ marginTop: 25 }}>Price Info</Divider>
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="Client">{data.client}</Descriptions.Item>
          <Descriptions.Item label="Product">{data?.product?.productName}</Descriptions.Item>
          <Descriptions.Item label="Price Id">
            <Text copyable={{ text: data.id }}>{data.id}</Text>
          </Descriptions.Item>
        </Descriptions>
        <Divider>Product</Divider>
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="Width">{data.labelWidth}</Descriptions.Item>
          <Descriptions.Item label="Height">{data.labelHeight}</Descriptions.Item>
          <Descriptions.Item label="Machine">{data.machine}</Descriptions.Item>
          <Descriptions.Item label="Material">{data.material}</Descriptions.Item>
          <Descriptions.Item label="Knife">{data.knifeCode}</Descriptions.Item>
        </Descriptions>
        <Divider>Print</Divider>
        <Descriptions size="small" column={2}>
          <Descriptions.Item label="CMYK">{data.print.cmykColors}</Descriptions.Item>
          <Descriptions.Item label="Pantone">{data.print.pantoneColors}</Descriptions.Item>
          <Descriptions.Item label="White">{data.print.coveringWCount}</Descriptions.Item>
          <Descriptions.Item label="Gold/Silver">{data.print.goldOrSilver}</Descriptions.Item>
          <Descriptions.Item label="Varnish">{data.print.varnishType}</Descriptions.Item>
          <Descriptions.Item label="Foil Count">{data.print.foilCount}</Descriptions.Item>
        </Descriptions>
        {returnPrices(data.dynamicPrice, data.dynamicFixedPrice, data.advanced.fixedPrice)}
      </Drawer>
    </>
  )
}
